module.exports = __webpack_public_path__ + "img/symbol_5.ba5ea813.png";